module.exports = __webpack_public_path__ + "img/freshbooks.118ac69a.png";